'use client'

import React from 'react'

import ImageConverterLayout from '../ImageConverterLayout'


export default function JPGConverter() {
  return (
    <ImageConverterLayout
      targetFormat={'jpg'}
      downloadFileExt={'.jpg'}
    />
  )
}
